class redeem{
	constructor(redeemptionOption){
		this.redeemptionOption=redeemptionOption;
	}
	renderRedeemptionOption(){
		this.redeemptionOption.forEach((option,index)=>{
			if(option.discount_type==="fixed_amount"){		
				$(".redeemOptions").append(
					$("<div>").addClass("redeemOption").addClass("swell-redemption-link").append(
						$("<h4>").text(`${option.prettyDiscount} OFF`),
						$("<p>").text(`${option.amount} Points`)).addClass("swell-redemption-link").attr({
                            "data-redemption-option-id": option.id

                        }) )
			}
		})
	}
}

	